import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  button: css`
    position: absolute;
    inset-block-start: ${spacing(1)};
    inset-inline-start: ${spacing(1)};
  `,
}
